/** "Results" bar-chart icon for the top bar's results panel button. */
export function ChartIcon() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
    >
      <path d="M4 20V10M12 20V4M20 20v-7" />
    </svg>
  );
}
